import React, { useState, useEffect } from 'react';
import { adminApi, FeedbackItem } from '../services/adminApi';

interface FeedbackProps {
    onError?: (error: string) => void;
}

const Feedback: React.FC<FeedbackProps> = ({ onError }) => {
    const [feedbackItems, setFeedbackItems] = useState<FeedbackItem[]>([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        loadFeedback();
    }, []);

    const loadFeedback = async () => {
        setLoading(true);
        try {
            const feedbackResponse = await adminApi.getAllFeedback();
            if (feedbackResponse.status === 'success' && feedbackResponse.data) {
                setFeedbackItems(feedbackResponse.data.feedback);
            } else {
                const errorMessage = feedbackResponse.message || 'Failed to load feedback';
                if (onError) {
                    onError(errorMessage);
                }
            }
        } catch (err) {
            const errorMessage = 'Failed to load feedback';
            if (onError) {
                onError(errorMessage);
            }
        } finally {
            setLoading(false);
        }
    };

    if (loading) {
        return (
            <div className='space-y-6'>
                <h2 className='text-2xl font-bold text-gray-900'>User Feedback</h2>
                <div className='text-center py-8'>
                    <div className='animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto'></div>
                    <p className='mt-4 text-gray-600'>Loading...</p>
                </div>
            </div>
        );
    }

    return (
        <div className='space-y-6'>
            <h2 className='text-2xl font-bold text-gray-900'>User Feedback</h2>
            <div className='bg-white rounded-lg shadow overflow-hidden'>
                <table className='min-w-full divide-y divide-gray-200'>
                    <thead className='bg-gray-50'>
                        <tr>
                            <th className='px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider'>
                                Player ID
                            </th>
                            <th className='px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider'>
                                Feedback
                            </th>
                            <th className='px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider'>
                                Date
                            </th>
                        </tr>
                    </thead>
                    <tbody className='bg-white divide-y divide-gray-200'>
                        {feedbackItems.map(item => (
                            <tr key={item.id}>
                                <td className='px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900'>
                                    {item.playerId}
                                </td>
                                <td className='px-6 py-4 text-sm text-gray-900'>{item.text}</td>
                                <td className='px-6 py-4 whitespace-nowrap text-sm text-gray-500'>
                                    {new Date(item.created).toLocaleDateString()}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default Feedback;

